/*============================*/
/* "Wait until exists" plugin. */
/*============================*/

(function(e,f){var b={},g=function(a){b[a]&&(f.clearInterval(b[a]),b[a]=null)};e.fn.waitUntilExists=function(a,h,j){var c=this.selector,d=e(c),k=d.not(function(){return e(this).data("waitUntilExists.found")});"remove"===a?g(c):(k.each(a).data("waitUntilExists.found",!0),h&&d.length?g(c):j||(b[c]=f.setInterval(function(){d.waitUntilExists(a,h,!0)},500)));return d}})(jQuery,window);

/*============================*/
/* Update main product image. */
/*============================*/
var switchImage = function(newImageSrc, newImage, mainImageDomEl) {
  // newImageSrc is the path of the new image in the same size as originalImage is sized.
  // newImage is Shopify's object representation of the new image, with various attributes, such as scr, id, position.
  // mainImageDomEl is the passed domElement, which has not yet been manipulated. Let's manipulate it now.
  jQuery(mainImageDomEl).parents('a').attr('href', newImageSrc.replace('_grande', '_1024x1024'));
  jQuery(mainImageDomEl).attr('src', newImageSrc);
};

jQuery(function($) {

  /* Placeholder JS */
  /*==========================*/
  var test = document.createElement('input');
  if (!('placeholder' in test)) {
    $('[placeholder]').each(function(){
      if ($(this).val() === '') {
        var hint = $(this).attr('placeholder');
        $(this).val(hint).addClass('hint');
      }
    });
    $('[placeholder]').focus(function() {
      if ($(this).val() === $(this).attr('placeholder')) {
        $(this).val('').removeClass('hint');
      }
    }).blur(function() {
      if ($(this).val() === '') {
        $(this).val($(this).attr('placeholder')).addClass('hint');
      }
    });
  }

  /* Form validation JS */
  /*==========================*/

  $('input.error, textarea.error').focus(function() {
    $(this).removeClass('error');
  });

  $('form :submit').click(function() {
    $(this).parents('form').find('input.hint, textarea.hint').each(function() {
      $(this).val('').removeClass('hint');
    });
    return true;
  });

  /* Remove SVG images to avoid broken images in all browsers that don't support SVG. */
  /*==========================*/

  var supportsSVG = function() {
    return document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#Image', '1.1');
  }
  if (!supportsSVG()) {
    $('img[src*=".svg"]').remove();
  }

  /* Prepare to have floated images fill the width of the design on blog pages on small devices. */
  /*==========================*/

  var images = $('.article img').load(function() {
    var src = $(this).attr('src').replace(/_grande\.|_large\.|_medium\.|_small\./, '.');
    var width = $(this).width();
    $(this).attr('src', src).attr('width', width).removeAttr('height');
  });

  /* Update main product image when a thumbnail is clicked. */
  /*==========================*/
  // $('.product-photo-thumb a').on('click', function(e) {
  //   e.preventDefault();
  //   switchImage($(this).attr('href'), null, $('.product-photo-container img')[0]);
  // } );

});

/* Update main product image when a thumbnail is clicked. */
  /*==========================*/
jQuery('.product-photo-thumb img').click(function() {
  jQuery('.product-photo-container img').attr('src', jQuery(this).attr('src'));
});

// Footer toggle menu
if ( $(window).width() < 960) {
  $(".main-footer__menu-toggle").click(function()
  {
    $(this).next(".toggle-menu").slideToggle(100);
  });
}

// Header alert toggle
$(".header__alert-bar--text .close").click(function(){
    $(".header__alert-bar").hide();
});

// Move search to Main nav block on desktop
if ( $(window).width() > 860) {
  $(".nav-search-container").appendTo( $(".nav-wrapper") );
}

// Header alert toggle
// $(".search-form .close").click(function(){
//     $(".nav-search-container").toggle();
//     $(".nav.desktop-tablet").toggle();
// });

// Toggle main menu
$(".menu-toggle").click(function() {
  $(".nav").slideToggle();
});

// Main nav toggle menus
if ( $(window).width() < 861) {
  $("li.has-dropdown").on('click', '.submenu--toggle', function(e) {
    var $this = $(this);
    e.preventDefault();
    if($this.children('.fa').hasClass('fa-angle-left')) {
      $this.children('.fa').removeClass('fa-angle-left').addClass('fa-angle-down');
    } else if ($this.children('.fa').hasClass('fa-angle-down')) {
      $this.children('.fa').removeClass('fa-angle-down').addClass('fa-angle-left');
    }
    $this.parent().children("ul.sub-nav").slideToggle();
  });
}

// Explore tab toggle
$("#explore").click(
  function() {
  $(".explore-container").show();
}, function() {
  var $exploreMenu = $(".explore-container");
  var $navItems = $(".nav li:not('#explore'), .pre-nav");
  $exploreMenu.mouseleave(function() { $exploreMenu.hide() });
  $navItems.one('mouseenter', function() {
    $exploreMenu.hide();
  });
});

// Account Menu Toggle
$(".customer-links-account").click(function() {
  $(".pre-nav__account-links").toggle();
});

// Cart Dropdown Toggle
$(".cart-toggle").click(function() {
  $(".cart-dropdown").toggle();
});

// Search tab toggle
// $(".search-toggle").click(function() {
//   if (isMobile()) {
//     setTimeout(function() {$('#search-field').trigger('touchstart');}, 200);
//   } else {
//     $(".nav-search-container").toggle();
//     $('#search-field').focus();
//   }
//   if ($(window).width() > 860) {
//     $(".nav.desktop-tablet").toggle();
//   }
// });

// Filters toggle
$(".toggle-gift-image").click(function() {
  if ( $(window).width() < 861) {
    $(".sec-collection-filters").toggle();
  }
});

// Sticky Header
// if ( $(window).width() > 960) {
//   $(document).ready(function(){
//     $(".main-header").sticky({
//       topSpacing: 0,
//       zIndex: 999
//     });
//   });
// }



// Show Nav for the first minute of a session
if (Cookies.get('alert-bar') === undefined) {
  var d = new Date(); d.setMinutes(d.getMinutes() + 2);
  $('.header__alert-bar').show();
  Cookies.set('alert-bar', d.toISOString(), { expires: 2 });
} else if (new Date() < Date.parse(Cookies.get('alert-bar'))) {
  $('.header__alert-bar').show();
}

// $('.main-header').on('sticky-start', function() { $('#main').css({'margin-top': '125px' }) } );
// $('.main-header').on('sticky-end', function() { $('#main').css({'margin-top': '0px' }) } );

// Product sticky header add to cart
// button and vars.

$('.qty-select').on('change', function() {
  $('.qty-select').val($(this).val());
})

// $('#product-sticky-header--add-to-cart').on('click', function() {
//   $('#add').trigger('click');
//   $('#add-bundle').trigger('click');
// })

$('#review_header .stars').waitUntilExists(function() {
  if (!$('.merchantheader').length) {
    $('#product_just_stars').html($(this).html());
  } else {
    $('.no-reviews').show();
    $('#product_just_stars').hide();
  }
}, true);

$('#customize-bundle').on('click', function(e) {
  e.preventDefault();
  
  $('html, body').animate({
    scrollTop: $('#customize-target').offset().top - 100
  }, 500);
});

$('.desc-read-more').on('click', function() {
   $('html, body').animate({
        scrollTop: $("#about").offset().top - 100
    }, 500);
})

$('.selector-wrapper').waitUntilExists(function() {
  $('.selector-wrapper label').addClass('column third');
  $('.selector-wrapper select').addClass('column two-thirds');
}, true)

//Redecorate the address table form.
if (window.location.pathname.indexOf('account/address') !== -1) {
  $('.customer_address_table tr').each(function(idx, el) { $(el).children('.value').first().prepend($(el).children('.label').first()) });
}

//User-agent test for mobile devices
function isMobile() {
  return /iPhone|iPad/i.test(navigator.userAgent) || /Android\s[4-9]/i.test(navigator.userAgent) || /Windows Phone\s[8-9]/i.test(navigator.userAgent)
}

$('.qty-select').on('change keyup', function(e) {
  var $input = $(this);
  var max = parseInt($input.attr('max'));
  if ($input.val() > max) {
    $input.val(max);
  }
});

$('.cart-qty-select').on('change keyup', function(e) {
    var $input = $(this);
    var max = parseInt($input.attr('max'));
    if ($input.val() > max) {
      $input.val(max);
    }
});

$('.pre-nav .cart-link-wrapper').hover(function() {
  $('.cart-dropdown').show();
}, function() {
  $('.cart-dropdown').hide();
});

var nodeList = [];

// $('.sticky-cart').hover(function() {
//   $('.cart-dropdown').show();
// }, function() {
//   setTimeout(function() {
//     nodeList = document.querySelectorAll( ":hover" );
//     var nodearr = Array.prototype.slice.call(nodeList);
//     if (nodearr.indexOf($('.cart-dropdown')[1]) == -1) {
//       $('.cart-dropdown').hide();
//     }
//   }, 500);
// });

$('.customer-links').hover(function() {
  $('.pre-nav__account-links').show();
}, function() {
  $('.pre-nav__account-links').hide();
});

// $('#sticky-qty').attr('max', $('#qty-input').attr('max'));